<template>
  <section>
    <h1 class="section-head">รายการใบเสนอราคา</h1>
    <nav class="level">
      <div class="level-left">
        <div class="level-item">
          <button class="button" @click="init">Refresh</button>
          <b-input placeholder="Search..." v-model="search_query" type="search" icon="search" icon-pack="fas" width="250"></b-input>
        </div>
      </div>
      <div class="level-right">
        <div class="level-item">
          <div class="buttons">
            <router-link class="button is-info is-pulled-right" :to="('/quotation/add')" v-can="'add_quotation'"><i class="fas fa-clipboard-list"></i>เพิ่มใบเสนอราคา</router-link>
          </div>
        </div>
      </div>
    </nav>
    
    <div>
      <b-table
        :data="filteredData"
        selectable @click="selected"
        :selected.sync="selectedItem"
        :hoverable="true"
        :loading="isTableLoading"
        :paginated="isPaginated"
        :per-page="perPage"
        :current-page.sync="currentPage"
        :pagination-simple="isPaginationSimple"
        :narrowed="true"

        v-if="quotations.length > 0 || isTableLoading"
      >
        <template slot-scope="props">
          <b-table-column field="id" label="รหัส" width="180">
            <strong>
              {{ props.row.code }}
            </strong>
          </b-table-column>

          <b-table-column field="name" label="Company">
              {{ props.row.company ? props.row.company : "ยังไม่ระบุ"}} {{ props.row.name ? " - "+props.row.name : ""}}
          </b-table-column>

          <b-table-column field="amount" label="จำนวน (รายการ)">
              {{ props.row.items.length }}
          </b-table-column>

          <b-table-column field="total_price" label="ราคารวม (บาท)">
              {{ props.row.total_price ? parseFloat(props.row.total_price).formatMoney(2):0 }} บาท
          </b-table-column>

          <b-table-column field="ship_status" label="สถานะ">
            <span class="tag is-warning" v-if="props.row.ord_id == '0'">รอการอนุมัติ</span>
            <span class="tag is-success" v-else>อนุมัติแล้ว</span>
          </b-table-column>
          
        </template>
      </b-table>
      <div class="notification has-text-centered" v-else>ไม่พบข้อมูล</div>
    </div>
  </section>
</template>

<script>
  import QuotationModel from '@/model/quotation_model'
  import Const from '@/const/const'

  export default {
    data() {
      return {
        quotations: [],
        isTableLoading: false,
        selectedItem: null,

        isPaginated: true,
        isPaginationSimple: false,
        currentPage: 1,
        perPage: 20,
        search_query: "",
      }
    },
    mounted() {
      this.init();
    },
    computed: {
      filteredData: function() {
        return this.quotations.filter(quotation => {
          return (
                  (quotation.code && quotation.code.toLowerCase().includes(this.search_query.toLowerCase()))
                  || (quotation.company && quotation.company.toLowerCase().includes(this.search_query.toLowerCase()))
                )
        })
      }
    },
    methods:{
      async init(){
        this.isTableLoading = true;
        this.quotations = await QuotationModel.get_quotation();
        this.isTableLoading = false;
      },
      selected(item) {
        if(!this.can("add_quotation|edit_quotation|delete_quotation|view_quotation|download_quotation_pdf|add_order")){
          this.$buefy.toast.open('คุณไม่มีสิทธิ์ที่จะเข้าถึงส่วนนี้!');
          return;
        }
        if(this.lastSelected == item){
          this.$router.push({ path: '/quotation/view/'+item.id })
        }
        this.lastSelected = item;
      }
    }

  }
</script>

<style scoped>
  .table-style {
    font-size: 0.8rem;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Quotation/index.vue